module.exports = __webpack_public_path__ + "img/banner12.4ae7094a.jpg";